import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // Import getAuth

const firebaseConfig = {
  apiKey: "AIzaSyDfTfUGKiL-4DG5FMQ_h1rF-Y-oOHX6VjQ",
  authDomain: "student-login-4851b.firebaseapp.com",
  projectId: "student-login-4851b",
  storageBucket: "student-login-4851b.firebasestorage.app",
  messagingSenderId: "163434459344",
  appId: "1:163434459344:web:75c2ee4d1aaab987b56ed5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig); 
const db = getFirestore(app);
const auth = getAuth(app); // Initialize Auth and get the instance

export { db, auth };